import React, { FC } from 'react';

import { useEthers } from '@usedapp/core';

import { RABBY_AVATAR_URL } from '../../../../context/constants';
import { useDispatch, useTrackedState } from '../../../../context/store';

import { redirectAfterLogin } from '../../../../helpers';

import { ConnectBubble, ConnectButton, WalletDisplay } from './styled';

const RabbyConnectButton: FC = () => {
  const { activateBrowserWallet } = useEthers();
  const { loginFrom } = useTrackedState();
  const dispatch = useDispatch();

  return (
    <ConnectButton
      fullWidth
      design="flat"
      onClick={(e: React.UIEvent<HTMLElement>) => {
        e.stopPropagation();

        activateBrowserWallet({ type: 'rabby' });

        if (loginFrom) {
          redirectAfterLogin(loginFrom, dispatch);
        }
      }}
    >
      <div>
        <img
          src={RABBY_AVATAR_URL}
          width="32px"
          height="32px"
          alt="Rabby"
          style={{ background: 'white', borderRadius: '50px' }}
        />
        <WalletDisplay>
          <span>Rabby Wallet</span>
        </WalletDisplay>
      </div>
      <ConnectBubble>Connect</ConnectBubble>
    </ConnectButton>
  );
};

export default RabbyConnectButton;
